module.exports = __webpack_public_path__ + "media/svg/sb-c40fc3f7.svg";